export default __webpack_public_path__ + "assets/images/fbfac37d9b8cf73f5e77813ffcd00e90.jpeg";